// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__28A84"};